"use strict";

//
// Very minimal mock so we can assert different things about the logger
// during test runs
//
// -- Usage
//
// Mock the logger module use the *mock-require* module, or any other mocking module that
// does a simlar thing
//
// ``` testSetup.js
// const mock = require('mock-require')
// const loggerMock = require('@adc/logger').mock
//
// mock('@adc/logger', loggerMock)
// ```
//
// Place the *resetBeforeEach* in your mocha describe block to suppress and track logger output for
// the whole block.
//
// ``` test.js
// describe('test with logger assertions', () => {
//   loggerMock.resetBeforeEach()
// })
// ```
//
var state = 0; // Wrap this in a function so we don't export an initial object that we then
// replace later. We want to change the underlying object after each test

var getState = function getState() {
  return state;
};

var trapCall = function trapCall(level) {
  return function () {
    state.callCount++;
    state[level].callCount++;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    state[level].calls.push(args);
  };
};

var lastCall = function lastCall(level) {
  return function () {
    var calls = state[level].calls;
    return calls[calls.length - 1];
  };
};

var resetState = function resetState() {
  state = {
    callCount: 0
  };
  ['error', 'info', 'debug', 'warn'].forEach(function (level) {
    state[level] = {
      calls: [],
      callCount: 0,
      lastCall: lastCall(level)
    };
  });
}; // Call once to set


resetState();

var resetBeforeEach = function resetBeforeEach() {
  return beforeEach(resetState);
};

var noop = function noop() {};

var mock = {
  state: getState,
  resetBeforeEach: resetBeforeEach,
  error: trapCall('error'),
  info: trapCall('info'),
  warn: trapCall('warn'),
  debug: trapCall('debug'),
  middleware: function middleware(opts) {
    return function (req, res, next) {
      return next();
    };
  },
  forModule: function forModule(str) {
    return mock;
  },
  // NOTE: This is fake, just to match the interface. The main reason for this is because we don't presently
  // have any formal specification of what adapters are compatible with which env. The `DatadogAdapter` is only
  // applicable for a node environment, and should never be used in the browser.
  outputAdapters: {},
  configuration: {
    get: noop,
    set: noop,
    update: noop,
    reset: noop
  },
  addSanitizedKeys: noop,
  flushAll: noop,
  stream: {
    write: function write() {
      return mock.warn.apply(mock, arguments);
    }
  },
  RequestLogger: function RequestLogger() {
    this.request = function () {};

    this.response = function () {};
  }
};
module.exports = mock;